import { render, staticRenderFns } from "./ScoreRow.vue?vue&type=template&id=733b77ca&scoped=true"
import script from "./ScoreRow.vue?vue&type=script&lang=js"
export * from "./ScoreRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733b77ca",
  null
  
)

export default component.exports